export default __webpack_public_path__ + "static/media/dronecontrol.66dc4660.jpeg";